import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import logo from '../../assets/images/logo.jpg'
import Api from '../../component/Api';
import Loading from "../../component/loader/Loading";
import './Login.css'


// const api = `${Api}user?email=`;

const Login = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const usenavigate = useNavigate();

    useEffect(() => {
        sessionStorage.clear();
    }, []);

    const ProceedLogin = (e) => {
        e.preventDefault();
        if (validate()) {
            setIsLoading(true);
            fetch(`${Api}/user?email=${email}`)
                .then((res) => { return res.json(); })
                .then((resp) => {
                    // console.log(resp)
                    setIsLoading(false);
                    if (Object.keys(resp).length === 0) {
                        toast.error('Please Enter valid email');
                    } else {
                        if (resp[0].password === password) {
                            const username = resp[0].name;
                            const id = resp[0].id;
                            toast.success('Success');
                            sessionStorage.setItem('username', username);
                            sessionStorage.setItem('email', email);
                            sessionStorage.setItem('userId', id);
                            if (email === "audirezk@gmail.com") usenavigate('/admin')
                            else usenavigate('/account')
                        } else {
                            toast.error('Please Enter correct password');
                        }
                    }
                }).catch((err) => {
                    toast.error('Login Failed due to :' + err.message);
                    setIsLoading(false);
                });
        }
    }

    const validate = () => {
        let result = true;
        if (email === '' || email === null) {
            result = false;
            toast.warning('Please Enter email');
        }
        if (password === '' || password === null) {
            result = false;
            toast.warning('Please Enter Password');
        }
        return result;
    }
    return (

        <form onSubmit={ProceedLogin} className="container text-center login">
            {isLoading ? <Loading /> : " "}
            <div data-aos="zoom-in-down">
                <img className="mb-4 imgLogin" src={logo} alt=""/>
                <h1 className="h3 mb-3 fw-normal">Please Login </h1>

                <div className="form-floating mt-2 mb-2">
                    <input type="email" className="form-control" id="floatingInput" placeholder="name@example.com" value={email} onChange={e => setEmail(e.target.value)} />
                    <label htmlFor="floatingInput">Email address</label>
                </div>
                <div className="form-floating mt-2 mb-2">
                    <input type="password" className="form-control" id="floatingPassword" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} />
                    <label htmlFor="floatingPassword">Password</label>
                </div>

                <button className="w-100 btn btn-lg btn-primary mt-2 mb-2" type="submit">login</button>
                <Link to={"/register"} className="w-100 btn btn-lg btn-secondary">register</Link>

            </div>
        </form>

    );
}


export default Login;